import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './auth.interceptor';
import { CommonModule } from '@angular/common';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

// icons
import { TablerIconsModule } from 'angular-tabler-icons';
import * as TablerIcons from 'angular-tabler-icons/icons';

//Import all material modules
import { MaterialModule } from './material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

//Import Layouts
import { FullComponent } from './layouts/full/full.component';
import { BlankComponent } from './layouts/blank/blank.component';

// Vertical Layout
import { SidebarComponent } from './layouts/full/sidebar/sidebar.component';
import { HeaderComponent } from './layouts/full/header/header.component';
import { BrandingComponent } from './layouts/full/sidebar/branding.component';
import { AppNavItemComponent } from './layouts/full/sidebar/nav-item/nav-item.component';
import { CustomersComponent } from './partners/customers/customers.component';
import { VendorsComponent } from './partners/vendors/vendors.component';
import { VendorSignupComponent } from './partners/vendors/vendor-signup/vendor-signup.component';
import { VendorSigninComponent } from './partners/vendors/vendor-signin/vendor-signin.component';
import { VendorRegisterComponent } from './partners/vendors/vendor-register/vendor-register.component';
import { VendorChangePasswordComponent } from './partners/vendors/vendor-change-password/vendor-change-password.component';
import { CustomerSigninComponent } from './partners/customers/customer-signin/customer-signin.component';
import { CustomerSignupComponent } from './partners/customers/customer-signup/customer-signup.component';
import { CustomerForgotPasswordComponent } from './partners/customers/customer-forgot-password/customer-forgot-password.component';
import { CustomerResetPasswordComponent } from './partners/customers/customer-reset-password/customer-reset-password.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { MatCardModule } from '@angular/material/card';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { VendorDashboardComponent } from './pages/vendor-dashboard/vendor-dashboard.component';
import { AuthCallbackComponentComponent } from './partners/customers/auth-callback-component/auth-callback-component.component';
import { AnalyticsErrorHandler } from './shared/analytics/analytics-error.handler';
import { LegalModalComponent } from './shared/legal/legal-modal/legal-modal.component';

@NgModule({
  declarations: [
    AppComponent,
    FullComponent,
    CustomersComponent,
    VendorsComponent,
    BlankComponent,
    SidebarComponent,
    HeaderComponent,
    BrandingComponent,
    AppNavItemComponent,
    ConfirmDialogComponent,
    VendorSignupComponent,
    VendorSigninComponent,
    VendorRegisterComponent,
    VendorChangePasswordComponent,
    VendorDashboardComponent,
    CustomerSigninComponent,
    CustomerSignupComponent,
    CustomerForgotPasswordComponent,
    CustomerResetPasswordComponent,
    AuthCallbackComponentComponent,
    LegalModalComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    TablerIconsModule.pick(TablerIcons),
    MatDatepickerModule,
    MatInputModule,
    MatNativeDateModule,
    MatDialogModule,
    MatSnackBarModule,
    CommonModule,
    MatCardModule,
    MatExpansionModule,
    MatProgressSpinnerModule,
  ],
  exports: [TablerIconsModule],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    // Reports uncaught errors so an abandonment spike can be checked against
    // an error spike on the same screen. Still logs to the console — replacing
    // Angular's default without re-logging would hide every error from
    // developers.
    { provide: ErrorHandler, useClass: AnalyticsErrorHandler },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
